<template>
  <div class="slider-list-container">
    <div v-for="(slider,index) in items" :key="index" class="slider-item-container" v-show="position === index">
      <div class="slider-overlay" @click="onClickEditSlider()">
        <div class="edit-button">
          <i class="fa fa-pencil fa-2x" />
        </div>
      </div>
      <SliderItem :data="slider" />
    </div>
    <div class="bullet-container" v-if="hasItems">
      <div
        class="bullet"
        :class="{'selected': position === count}"
        v-for="(bullet, count) in items.length"
        :key="count"
        @click="setPosition(count)" />
    </div>
    <EmptyMessage class="empty-container" v-if="!hasItems">
      <button
        class="btn btn-light btn-lg mt-4"
        type="button"
        @click="onClickEditSlider()">
          จัดการสไลเดอร์
      </button>
    </EmptyMessage>
  </div>
</template>

<script>
import EmptyMessage from '@/components/EmptyMessage.vue';
import SliderItem from './SliderItem.vue';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    sliderId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      position: 0,
    };
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    hasItems() {
      if (!this.items) {
        return false;
      } if (this.items.length === 0) {
        return false;
      }
      return true;
    },
  },
  components: {
    SliderItem,
    EmptyMessage,
  },
  methods: {
    setPosition(index) {
      this.position = index;
    },
    onClickEditSlider() {
      this.$router.push(`${this.pageDesignerKey}/components/${this.sliderId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
.slider-list-container {
  position: relative;
  .bullet-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    justify-content: center;
    margin: $spacer 0;
    .bullet {
      cursor: pointer;
      width: 15px;
      height: 15px;
      margin-right: $spacer;
      border-radius: 15px;
      background: $gray-600;
    }
    .selected {
      background: $altv-mint;
    }
  }
  .slider-item-container {
    transition: all 0.2s ease-out;
    position: relative;
    .slider-overlay {
      cursor: pointer;
      position: absolute;
      transition: all 0.2s ease-out;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 2;
    }
    .edit-button {
      background: white;
      padding: $spacer / 1.5;
      margin-top: $spacer;
      margin-right: $spacer;
      border-radius: 15px;
      color: $gray-800;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .empty-container {
    background: white;
  }
}

@media (max-width: 575.98px) {
  .slider-list-container {
    .bullet {
      width: 10px !important;
      height: 10px !important;
    }
    .edit-button {
      font-size: 8px;
      border-radius: 10px !important;
    }
  }
}
</style>
